import React from "react";
import CorrectionForm from '../components/correctionForm';

const Correction = () => {
  const token = localStorage.getItem("token");

  return (
    <div className="bg-gray">
      <CorrectionForm token={token} />
    </div>
  );
};

export default Correction;
